import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const German = () => {
  return (
    <SvgIcon height={15} width={24}>
      <g id="german" transform="translate(-586 -8)">
        <path
          id="Rechteck_235"
          data-name="Rechteck 235"
          d="M2,0H22a2,2,0,0,1,2,2V5a0,0,0,0,1,0,0H0A0,0,0,0,1,0,5V2A2,2,0,0,1,2,0Z"
          transform="translate(586 8)"
        />
        <rect
          id="Rechteck_236"
          data-name="Rechteck 236"
          width="24"
          height="5"
          transform="translate(586 13)"
          fill="#ff3e00"
        />
        <path
          id="Rechteck_237"
          data-name="Rechteck 237"
          d="M0,0H24a0,0,0,0,1,0,0V3a2,2,0,0,1-2,2H2A2,2,0,0,1,0,3V0A0,0,0,0,1,0,0Z"
          transform="translate(586 18)"
          fill="#ff0"
        />
      </g>
    </SvgIcon>
  );
};

export default German;
